import React from 'react';

const VisaIcon: React.FC<{className?: string}> = ({ className = "w-12 h-8" }) => (
  <svg className={className} viewBox="0 0 48 32" fill="none">
    <rect width="48" height="32" rx="4" fill="white"/>
    <text x="24" y="21" textAnchor="middle" fontWeight="bold" fontSize="14" fill="#0066CC" fontFamily="Arial">VISA</text>
  </svg>
);

export default VisaIcon; 